import { useEffect, useState } from 'react'
import { HistoryView } from '../../views'
import { UsageService, LocalStorageService } from '../../../services'
import { useGlobalState } from '../../../GlobalState'
import moment from 'moment'

const DEFAULT_PAGE = 1
const DEFAULT_LIMIT = 10
const SEARCH_DEBOUNCE_MS = 700

const HistoryAction = () => {
  const url = process.env.REACT_APP_ETICKET_API
  const usageService = new UsageService(url)
  const localStorageService = new LocalStorageService()
  const token = localStorageService.getLocalStorageItem('token')?.accessToken
  const chatbotUrl = process.env.REACT_APP_CHATBOT_URL
  const { botConfig } = useGlobalState()
  
  const [dataConversations, setDataConversations] = useState(null)
  const [initialDataConversations, setInitialDataConversations] = useState(null)
  const [initialQueryParams, setInitialQueryParams] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [isLoadingChangePage, setIsLoadingChangePage] = useState(true)
  const [date, setDate] = useState(parseInt(moment().format('YYYYMM')))
  const [searchValue, setSearchValue] = useState('')
  const [debouncedSearchValue, setDebouncedSearchValue] = useState('')
  const [currentPage, setCurrentPage] = useState(DEFAULT_PAGE)
  const [currentLimit, setCurrentLimit] = useState(DEFAULT_LIMIT)
  const [currentSort, setCurrentSort] = useState(null)

  const monthYearOptions = Array.from({ length: 12 }, (_, i) => {
      const monthDate = moment().subtract(i, 'months')
      const value = parseInt(monthDate.format('YYYYMM'))
      return {
          value,
          text: monthDate.format('MMMM YYYY')
      }
  }).reverse()

  const handleChangeDate = (event) => {
      setDate(event.target.value.value)
  }

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      setDebouncedSearchValue(searchValue.trim())
    }, SEARCH_DEBOUNCE_MS)

    return () => clearTimeout(debounceTimeout)
  }, [searchValue])

  useEffect(() => {
    if (debouncedSearchValue) {
      handleSearchConversations(DEFAULT_PAGE, currentLimit, currentSort, debouncedSearchValue)
      return
    }

    handleLoadInitialConversations(DEFAULT_PAGE, currentLimit, currentSort)
  }, [date, botConfig?.id])

  useEffect(() => {
    if (!debouncedSearchValue) {
      const canRestoreInitialData = Boolean(
        initialDataConversations
        && initialQueryParams
        && initialQueryParams.page === currentPage
        && initialQueryParams.limit === currentLimit
        && initialQueryParams.sort === currentSort
        && initialQueryParams.date === date
        && initialQueryParams.botId === (botConfig?.id || null)
      )

      if (canRestoreInitialData) {
        setDataConversations(initialDataConversations)
        setCurrentPage(initialDataConversations.page || DEFAULT_PAGE)
        setIsLoading(false)
        setIsLoadingChangePage(false)
      } else if (!isLoading) {
        handleLoadInitialConversations(currentPage, currentLimit, currentSort)
      }
      return
    }

    handleSearchConversations(DEFAULT_PAGE, currentLimit, currentSort, debouncedSearchValue)
  }, [debouncedSearchValue])
  
  /**
   * @description method to get paginated conversation
   * @param page page number
   * @param limit number of registers by page
   */
  const handleLoadInitialConversations = async (page, limit, sort = null) => {
    try {
      setIsLoadingChangePage(true)
      const monthNumber = date % 100
      const yearNumber = Math.floor(date / 100)

      const response = await usageService.getConversationsByDateAndPageLimit(yearNumber, monthNumber, token, null, page, limit, sort)
      setInitialDataConversations(response)
      setInitialQueryParams({
        page,
        limit,
        sort,
        date,
        botId: botConfig?.id || null
      })
      setDataConversations(response)
      setCurrentPage(page)
      setCurrentLimit(limit)
      setCurrentSort(sort)
      setIsLoadingChangePage(false)
      isLoading && setIsLoading(false)
    } catch (error) {
      console.error(`An error has ocurred in usageAction: ${error}`)
      setIsLoadingChangePage(false)
    }
  }

  const handleSearchConversations = async (page, limit, sort = null, search = debouncedSearchValue) => {
    try {
      setIsLoadingChangePage(true)
      const monthNumber = date % 100
      const yearNumber = Math.floor(date / 100)

      const response = await usageService.searchConversationsByMessage(search, yearNumber, monthNumber, token, null, botConfig?.id || null, page, limit, sort)
      setDataConversations(response)
      setCurrentPage(page)
      setCurrentLimit(limit)
      setCurrentSort(sort)
      setIsLoadingChangePage(false)
      isLoading && setIsLoading(false)
    } catch (error) {
      console.error(`An error has ocurred in historySearchAction: ${error}`)
      setIsLoadingChangePage(false)
    }
  }

  const handleGetPaginatedConversation = async (page, limit, sort = null) => {
    if (debouncedSearchValue) {
      await handleSearchConversations(page, limit, sort, debouncedSearchValue)
      return
    }

    await handleLoadInitialConversations(page, limit, sort)
  }

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value)
  }

  return (
    <HistoryView
      isLoading={isLoading}
      isLoadingChangePage={isLoadingChangePage}
      dataConversations={dataConversations}
      date={date}
      handleChangeDate={handleChangeDate}
      monthYearOptions={monthYearOptions}
      chatbotUrl={chatbotUrl}
      handleGetPaginatedConversation={handleGetPaginatedConversation}
      searchValue={searchValue}
      handleSearchChange={handleSearchChange}
    />
  )
}

export { HistoryAction as default }